module.exports = __webpack_public_path__ + "img/resident-payment-method-empty.2ae28b66.png";